module.exports = __webpack_public_path__ + "static/media/KM.b3702227.png";